export default __webpack_public_path__ + "static/media/02.18364766.jpg";